<template>
  <div>
    <div id="shareContent">
      <img class="avatar" :src="shareContent.avatar" />
      <!-- 一般文字 -->
      <div :class="{ content: true, needMore: isNeedMoreBtn }" ref="content" v-html="shareContent.text"></div>
      <!-- 是否要顯示更多按鈕(貼文高度過高時顯示) -->
      <div v-if="isNeedMoreBtn" class="reed-more-btn" @click="isNeedMoreBtn = false">顯示更多</div>
      <div class="imgBox">
        <img class="shareImg" v-for="item in shareContent.img" :key="item" :src="item.indexOf('.mp4') > -1 ? require('@/assets/img/video.svg') : item" />
      </div>
    </div>
    <!-- 其他應用分享過來的連結 -->
    <div v-if="$route.name === 'ShareOtherPost'">
      <div class="imageBox">
        <img class="urlImg" :src="urlImg" @error="SET_DEFAULT_IMG()" />
        <div class="urlTitle">
          <div>{{ urlTitle }}</div>
        </div>
        <div class="urlDescription">
          <div>{{ urlDescription }}</div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapState, mapActions, mapMutations, mapGetters } from 'vuex';
export default {
  name: 'ShareContent',
  data() {
    return {
      postId: this.$route.params.postId,
      isNeedMoreBtn: false,
      flag: true
    };
  },
  computed: {
    ...mapState('EditPostModule', ['shareContent']),
    ...mapGetters('EditPostModule', ['otherApShareContent', 'urlImg', 'urlDescription', 'urlTitle'])
  },
  methods: {
    ...mapActions('EditPostModule', ['getShareData', 'parseURL']),
    ...mapMutations('EditPostModule', ['SET_OTHER_AP_SHARE_DATA', 'SET_DEFAULT_IMG']),
    // 組合其他應用的分享連結
    sortOutApUrl() {
      let payload = {
        token: this.$route.params.token,
        apName: this.$route.params.apName,
        targetId: this.$route.params.targetId
      };
      this.SET_OTHER_AP_SHARE_DATA(payload);
    },
    getUrlMetadata() {
      // 正則表達式找url
      const regex = /https?:\/\/(www\.)?[-a-zA-Z0-9@:%._\+~#=]{1,256}\.[a-zA-Z0-9()]{1,6}\b([-a-zA-Z0-9()@:%_\+.~#?&//=]*)/g;
      if (this.otherApShareContent.shareUrl.match(regex) !== null) {
        this.parseURL(this.otherApShareContent.shareUrl.match(regex));
      }
    }
  },
  mounted() {
    // 其他應用分享過來的(消息/買迷/活動等)
    if (this.$route.name === 'ShareOtherPost') {
      this.sortOutApUrl();
      this.getUrlMetadata();
    } else {
      this.getShareData(this.postId);
    }
  },
  updated() {
    // 要等DOM渲染完才能叫 this.$refs
    let textHeight = this.$refs.content.offsetHeight;
    if (this.flag) {
      if (textHeight > 95) {
        this.isNeedMoreBtn = true;
        this.flag = false;
      }
    }
  }
};
</script>

<style lang="scss" scoped>
#shareContent {
  width: 90vw;
  display: grid;
  grid-template-columns: 50px auto;
  grid-template-rows: auto auto;
  margin: 15px auto !important;
  .avatar {
    width: 50px;
    grid-column: 1/2;
    grid-row: 1/3;
    align-self: center;
    border-radius: 50%;
  }
  .content {
    margin-left: 2vw;
    &.needMore {
      height: 95px;
      overflow: auto;
    }
  }
  .reed-more-btn {
    color: $LaleGray8;
    font-size: 18px;
    text-align: center;
    position: relative;
    margin-top: -80px;
    padding-top: 80px;
    margin-bottom: 15px;
    background-image: linear-gradient(-180deg, rgba(255, 255, 255, 0) 0%, #fff 70%);
  }
  .imgBox {
    margin-left: 2vw;
    img {
      height: 50px;
      border-radius: 5px;
      margin-right: 1vw;
    }
  }
}

// 預覽Url圖片和文字
.imageBox {
  width: 90vw;
  display: grid;
  grid-template-columns: 25vw auto;
  grid-template-rows: auto auto;
  border: 1px solid rgba(0, 0, 0, 0.2);
  border-radius: 5px;
  margin: 0 auto;
  color: #999;
  min-height: 100px;
  max-height: 110px;
  overflow: hidden;
  .urlImg {
    width: 100%;
    grid-column: 1/2;
    grid-row: 1/3;
    align-self: center;
    height: 100%;
    object-fit: cover;
  }
  .urlTitle {
    grid-column: 2/3;
    grid-row: 1/2;
    margin-left: 2vw;
    font-weight: 600;
    color: #777;
    align-self: center;
    padding: 10px 5px 0px 5px;
    div {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
  .urlDescription {
    grid-column: 2/3;
    grid-row: 2/3;
    margin-left: 2vw;
    align-self: center;
    padding: 0 5px 5px 5px;
    div {
      display: -webkit-box;
      -webkit-line-clamp: 2;
      -webkit-box-orient: vertical;
      overflow: hidden;
    }
  }
}
</style>
<style>
#shareContent .content p {
  margin: 0;
  color: #999;
}
</style>
